// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    contactDate: t.Bool,
    firstName: t.Bool,
    lastName: t.Bool,
    methodOfContact: t.Bool,
    referenceNumber1: t.Bool,
    relationship: t.Bool
}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    contactDate: true,
    firstName: true,
    lastName: true,
    methodOfContact: true,
    referenceNumber1: true,
    relationship: true
});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/state/form-validation.js